// 转换价格
export function orderPrice(price){
  price +="";
  if(price.length<=2){
    price = "0." + (price.length<2?"0":"") + price;
  }else{
    price = price / 100
  }
  return price;
}
// 转换货币类型
export function orderCurrency(cur){
  switch (cur) {
    case "CNY": cur = "￥"; break;
    default: cur = "￥"; break;
  }
  return cur;
}
// 转换订单状态
export function orderStatus(status) {
  switch (status) {
    case "UNPAID": status = "待付款"; break;
    case "DURING": status = "支付中"; break;
    case "PAID": status = "已付款"; break;
    case "CANCEL": status = "取消订单"; break;
    case "REFUND": status = "全部退款"; break;
    case "REFUNDING": status = "全部退款中"; break;
    case "PART_REFUND": status = "部分退款"; break;
    case "PART_REFUNDING": status = "部分退款中"; break;
    case "COMPLETE": status = "已完成"; break;
    default: status = "--"; break;
  }
  return status;
}
// 转换订单支付类型
export function orderType(type) {
  switch (type) {
    case "alipay-pcweb": type = "支付宝"; break;
    case "wechat-pcweb": type = "微信"; break;
    case "yioks-transfer": type = "银行转账"; break;
    default: type = "--"; break;
  }
  return type;
}
